export default "__VITE_ASSET__720d4d6a__"